/* Size tables: CM / IN tabs. Works on any table with a Chest or Length column. */
(function () {
  var KEY = 'fi-units';
  function pref() { try { return localStorage.getItem(KEY) || 'cm'; } catch (e) { return 'cm'; } }
  function save(u) { try { localStorage.setItem(KEY, u); } catch (e) {} }

  function apply(table, u) {
    var cells = table.querySelectorAll('td[data-cm]');
    for (var i = 0; i < cells.length; i++) {
      var cm = parseFloat(cells[i].getAttribute('data-cm'));
      cells[i].textContent = u === 'in' ? (Math.round(cm / 2.54 * 4) / 4).toString() : cells[i].getAttribute('data-cm');
    }
    var note = table.__fiNote;
    if (note) note.textContent = u === 'in' ? note.getAttribute('data-in') : note.getAttribute('data-cm');
    var btns = table.__fiTabs.querySelectorAll('button');
    for (var j = 0; j < btns.length; j++) btns[j].setAttribute('aria-selected', btns[j].getAttribute('data-u') === u ? 'true' : 'false');
  }

  function init(table) {
    if (table.__fiTabs) return;
    var head = (table.querySelector('thead') || table).textContent.toLowerCase();
    if (head.indexOf('chest') < 0 && head.indexOf('length') < 0) return;
    var rows = table.querySelectorAll('tbody tr');
    for (var r = 0; r < rows.length; r++) {
      var tds = rows[r].querySelectorAll('td');
      for (var c = 1; c < tds.length; c++) {
        var v = tds[c].textContent.trim();
        if (/^\d+(\.\d+)?$/.test(v)) tds[c].setAttribute('data-cm', v);
      }
    }
    var next = table.nextElementSibling;
    if (next && next.tagName === 'P' && /cm/.test(next.textContent)) {
      next.setAttribute('data-cm', next.textContent);
      next.setAttribute('data-in', next.textContent.replace(/^cm/, 'in').replace(/±\s*1[–-]3\s*cm/, '±0.5–1in'));
      table.__fiNote = next;
    }
    var tabs = document.createElement('div');
    tabs.className = 'fi-units';
    tabs.setAttribute('role', 'tablist');
    tabs.innerHTML = '<button type="button" role="tab" data-u="cm">CM</button><button type="button" role="tab" data-u="in">IN</button>';
    table.parentNode.insertBefore(tabs, table);
    table.__fiTabs = tabs;
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var u = b.getAttribute('data-u'); save(u);
      var all = document.querySelectorAll('table');
      for (var k = 0; k < all.length; k++) if (all[k].__fiTabs) apply(all[k], u);
    });
    apply(table, pref());
  }

  function scan() { var t = document.querySelectorAll('.rte table, table'); for (var i = 0; i < t.length; i++) init(t[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(scan, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* Pre-order: sizes at zero stock that still sell show "Pre-order" and carry a line item note. */
(function () {
  var data = document.getElementById('fi-stock');
  if (!data) return;
  var stock; try { stock = JSON.parse(data.textContent); } catch (e) { return; }
  var note = 'Pre-order. Ships in about 6 weeks.';
  try { note = JSON.parse(document.getElementById('fi-preorder-copy').textContent) || note; } catch (e) {}
  var labels = {};

  function setText(btn, txt) {
    for (var i = 0; i < btn.childNodes.length; i++) {
      var n = btn.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) {
        if (!labels[btn.id || 'x']) labels[btn.id || 'x'] = n.textContent.trim();
        if (n.textContent.trim() !== txt) n.textContent = txt;
        return;
      }
    }
  }

  function sync() {
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (var f = 0; f < forms.length; f++) {
      var form = forms[f];
      var idEl = form.querySelector('input[name="id"]');
      if (!idEl) continue;
      var v = stock[idEl.value];
      var pre = !!(v && v.m && v.a && v.q <= 0);
      var btn = form.querySelector('button[name="add"]');
      var prop = form.querySelector('input[name="properties[Pre-order]"]');
      var line = form.querySelector('.fi-preorder');
      if (pre) {
        if (btn) setText(btn, 'Pre-order');
        if (!prop) { prop = document.createElement('input'); prop.type = 'hidden'; prop.name = 'properties[Pre-order]'; prop.value = 'Ships in about 6 weeks'; form.appendChild(prop); }
        if (!line) { line = document.createElement('p'); line.className = 'fi-preorder'; line.textContent = note; form.appendChild(line); }
      } else {
        if (btn && v && v.a && labels[btn.id || 'x'] && btn.textContent.indexOf('Pre-order') > -1) setText(btn, labels[btn.id || 'x']);
        if (prop) prop.remove();
        if (line) line.remove();
      }
    }
  }

  var t;
  function soon() { clearTimeout(t); t = setTimeout(sync, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  document.addEventListener('change', soon, true);
  document.addEventListener('click', soon, true);
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
})();
